import { PermissionDto } from '@/api/generated';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

export const PROCESS_DATA_PERMISSIONS: PermissionDto[] = [
  PermissionDto.MenuProcesses,
  PermissionDto.MenuOffers,
  PermissionDto.MenuCalendar,
];

export const hasAnyPermission = (
  permissions: PermissionDto[],
  required: PermissionDto[],
): boolean => required.some(permission => permissions.includes(permission));

export const useHasAnyPermission = (...required: PermissionDto[]): boolean => {
  const { permissions } = useUserContext();
  return hasAnyPermission(permissions, required);
};

export const useCanReadProcessData = (): boolean =>
  useHasAnyPermission(...PROCESS_DATA_PERMISSIONS);
